import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import { InvitationTrackerStatisticCardView } from '@app/v2/event/types/invitation-tracker.type'

type StatisticCardTextClasses = {
  default: string
  interactive: string
  selected: string
}

const LABEL_CLASSES: StatisticCardTextClasses = {
  default: 'tw-text-gray-500',
  interactive: 'tw-text-gray-500 [@media(hover:hover)]:group-hover/stat-card:tw-text-gray-700 group-focus-visible/stat-card:tw-text-gray-700',
  selected: 'tw-text-gray-700'
}

const VALUE_CLASSES: StatisticCardTextClasses = {
  default: 'tw-text-gray-700',
  interactive: 'tw-text-gray-700 [@media(hover:hover)]:group-hover/stat-card:tw-text-gray-900 group-focus-visible/stat-card:tw-text-gray-900',
  selected: 'tw-text-gray-900'
}

@Component({
  selector: 'app-invitation-tracker-statistic-card-content',
  standalone: true,
  imports: [NgClass],
  templateUrl: './invitation-tracker-statistic-card-content.component.html',
  host: {
    class: 'tw-contents'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvitationTrackerStatisticCardContentComponent {
  public readonly card = input.required<InvitationTrackerStatisticCardView>()

  public readonly labelClass = computed(() => this._resolveTextClass(LABEL_CLASSES))
  public readonly valueClass = computed(() => this._resolveTextClass(VALUE_CLASSES))

  /**
   * Pick the text color classes for the card's current state.
   * @param classes {StatisticCardTextClasses} - The classes per state.
   * @returns {string} - The classes to apply.
   */
  private _resolveTextClass(classes: StatisticCardTextClasses): string {
    const card = this.card()
    if (card.isSelected) return classes.selected
    return card.isClickable ? classes.interactive : classes.default
  }
}
